<template>
  <div :class="'container ' + 'container-' + gardenObj.theme">
    <div class="logo">
      <img
        v-if="bannerImg.length > 0"
        :src="'https://krk-pro-resource.oss-cn-beijing.aliyuncs.com/static/theme/' + bannerImg + '.png'"
        alt
      />
    </div>
    <div class="content">
      <div class="content-box">
        <h5 class="garden-name">{{gardenObj.name}}</h5>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
          <div v-for="(item, key) in gardenObj.itemList" :key="key">
            <el-form-item
              class="head-portrait"
              prop="imageUrl"
              v-if="item.itemCode === 'profile'"
              :rules="[
              { required: item.isRequired == 1, message: '请上传头像'}]"
            >
              <div class="head-portrait-item">
                <div :class="(item.isRequired == 1 ? 'head-portrait-required' : '')"></div>
                <span>头像</span>
                <span class="profile">Profile Photo</span>
              </div>
              <el-upload
                class="avatar-uploader"
                :action="upload_url"
                :headers="uploadHeader"
                name="file"
                :data="otherNeedParams"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              prop="chineseName"
              v-if="item.itemCode === 'chineseName'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入中文姓名', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                宝宝姓名
                <span class="form-english-label">Child Name</span>
              </div>
              <el-input v-model="ruleForm.chineseName"></el-input>
            </el-form-item>
            <el-form-item
              prop="englishName"
              v-if="item.itemCode === 'englishName'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入英文姓名', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                英文姓名
                <span class="form-english-label">Engilsh Name</span>
              </div>
              <el-input v-model="ruleForm.englishName"></el-input>
            </el-form-item>
            <el-form-item
              prop="wechatId"
              v-if="item.itemCode === 'wechatId'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入微信号', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                微信号
                <span class="form-english-label">Wechat ID</span>
              </div>
              <el-input v-model="ruleForm.wechatId"></el-input>
            </el-form-item>
            <el-form-item
              prop="sex"
              v-if="item.itemCode === 'sex'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入选择性别', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                性别
                <span class="form-english-label">Gender</span>
              </div>
              <div class="form-item-sex">
                <el-radio-group v-model="ruleForm.sex">
                  <el-radio :label="10">男 Boy</el-radio>
                  <el-radio :label="11">女 Girl</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item
              prop="secondChildSex"
              v-if="item.itemCode === 'secondChildSex'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入选择性别', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                二宝性别
                <span class="form-english-label">Second Child's Gender</span>
              </div>
              <div class="form-item-sex">
                <el-radio-group v-model="ruleForm.secondChildSex">
                  <el-radio :label="10">男 Boy</el-radio>
                  <el-radio :label="11">女 Girl</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item
              prop="relationship"
              v-if="item.itemCode === 'relationship'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择与宝宝的关系', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                与宝宝关系
                <span class="form-english-label">Relationship</span>
              </div>
              <div class="form-item-sex">
                <el-radio-group v-model="ruleForm.relationship">
                  <el-radio :label="1">爸爸 Dad</el-radio>
                  <el-radio :label="2">妈妈 Mom</el-radio>
                  <el-radio :label="3">爷爷 Grandpa</el-radio>
                  <el-radio :label="4">奶奶 Grandma</el-radio>
                  <el-radio :label="5">外公 Grandpa</el-radio>
                  <el-radio :label="6">外婆 Grandma</el-radio>
                  <el-radio :label="7">姑姑 Aunt</el-radio>
                  <el-radio :label="8">舅舅 Uncle</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item
              prop="birthday"
              v-if="item.itemCode === 'birthday'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择生日', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                生日
                <span class="form-english-label">Date of Birth</span>
              </div>
              <el-input
                v-model="ruleForm.birthday"
                :readonly="readonly"
                onfocus="this.blur()"
                @click.native="birthdayOpenPicker"
                class="birthday"
              ></el-input>
              <!-- <input type="text" v-model="ruleForm.birthday" :readonly='true' @click="birthdayOpenPicker" class="birthday"/> -->
              <mt-datetime-picker
                ref="birthdayPicker"
                type="date"
                @confirm="birthdayHandleConfirm"
                v-model="pickerValue"
              ></mt-datetime-picker>
            </el-form-item>
            <el-form-item
              prop="secondChildBirthday"
              v-if="item.itemCode === 'secondChildBirthday'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择生日', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                二宝生日
                <span class="form-english-label">Second Child's Birthday</span>
              </div>
              <el-input
                v-model="ruleForm.secondBirthday"
                :readonly="readonly"
                onfocus="this.blur()"
                @click.native="secondBirthdayOpenPicker"
                class="birthday"
              ></el-input>
              <!-- <input type="text" v-model="ruleForm.birthday" :readonly='true' @click="birthdayOpenPicker" class="birthday"/> -->
              <mt-datetime-picker
                ref="secondBirthdayPicker"
                type="date"
                @confirm="secondBirthdayHandleConfirm"
                v-model="secondPickerValue"
              ></mt-datetime-picker>
            </el-form-item>
            <el-form-item
              prop="startDate"
              v-if="item.itemCode === 'startDate'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择期望入园时间', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                期望入园时间
                <span class="form-english-label">Start Date</span>
              </div>
              <el-input
                v-model="ruleForm.startDate"
                :readonly="readonly"
                @click.native="startDateOpenPicker"
                class="birthday"
              ></el-input>
              <mt-datetime-picker
                ref="startDatePicker"
                type="date"
                @confirm="startDateHandleConfirm"
                v-model="startDatePickerValue"
              ></mt-datetime-picker>
            </el-form-item>
            <el-form-item
              prop="name"
              v-if="item.itemCode === 'enrollPerson'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入报名人', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                报名人
                <span class="form-english-label">Your Name</span>
              </div>
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <div>
              <el-form-item prop="number" v-if="item.itemCode === 'number' && item.isRequired == 1">
                <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                  手机号码
                  <span class="form-english-label">Phone Number</span>
                </div>
                <el-input v-model="ruleForm.number"></el-input>
              </el-form-item>
              <el-form-item v-else-if="item.itemCode === 'number' && item.isRequired == 0">
                <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                  手机号码
                  <span class="form-english-label">Phone Number</span>
                </div>
                <el-input v-model="ruleForm.number" @blur="testNumber(item.isRequired)"></el-input>
                <div class="number-error" v-if="numberError.length > 0">{{numberError}}</div>
              </el-form-item>
            </div>

            <el-form-item
              prop="email"
              v-if="item.itemCode === 'email'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入邮箱', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur'] }
            ]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                邮箱
                <span class="form-english-label">Email</span>
              </div>
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item
              prop="address"
              v-if="item.itemCode === 'address'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入家庭住址', trigger: ['blur', 'change'] }
            ]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                家庭住址
                <span class="form-english-label">Your Home Address</span>
              </div>
              <div class="address">
                <el-select v-model="prov" placeholder="请选择">
                  <el-option
                    v-for="(option, index) in cityDatas"
                    :key="index"
                    :label="option.name"
                    :value="option.name"
                  ></el-option>
                </el-select>
                <el-select v-model="city" placeholder="请选择">
                  <el-option
                    v-for="(option, index) in cityArr"
                    :key="index"
                    :label="option.name"
                    :value="option.name"
                  ></el-option>
                </el-select>
                <el-select v-model="district" placeholder="请选择">
                  <el-option
                    v-for="(option, index) in districtArr"
                    :key="index"
                    :label="option.name"
                    :value="option.name"
                  ></el-option>
                </el-select>
              </div>
              <el-input v-model="ruleForm.address" placeholder="请输入详细地址（比如：某某小区)"></el-input>
            </el-form-item>
            <el-form-item
              prop="radio"
              v-if="item.itemCode === 'source'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择你是怎么知道我们的？', trigger: 'change' }
            ]"
            >
              <div
                :class="'form-label-note know form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')"
              >
                您是如何知道我们的？
                <br />
                <span class="form-english-label">How did you get to know us?</span>
              </div>
              <div class="form-item-sex radioGroup">
                <el-radio-group v-model="ruleForm.radio">
                  <el-radio
                    v-for="(row, index) in sourceArr"
                    :key="index"
                    :label="row.label"
                  >{{row.label}}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item
              prop="desc"
              v-if="item.itemCode === 'note'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入你的说明', trigger: 'blur' }
            ]"
            >
              <div
                :class="'form-label-note form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')"
              >
                您的关注和特别说明
                <span class="form-english-label">Note</span>
              </div>
              <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>
            <el-form-item
              prop="currentSchool"
              v-if="item.itemCode === 'currentSchool'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入在读学校', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                在读学校
                <span class="form-english-label">Current School</span>
              </div>
              <el-input v-model="ruleForm.currentSchool"></el-input>
            </el-form-item>
            <el-form-item
              prop="motherAge"
              v-if="item.itemCode === 'motherAge'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入年龄', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                孩子母亲的年龄
                <span class="form-english-label">Mother's Age</span>
              </div>
              <el-input type="number" :max="99" :min="0" v-model="ruleForm.motherAge"></el-input>
            </el-form-item>
            <el-form-item
              prop="fatherAge"
              v-if="item.itemCode === 'fatherAge'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入年龄', trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                孩子父亲的年龄
                <span class="form-english-label">Father's Age</span>
              </div>
              <el-input type="number" :max="99" :min="0" v-model="ruleForm.fatherAge"></el-input>
            </el-form-item>
            <el-form-item
              prop="primaryCare"
              v-if="item.itemCode === 'primaryCare'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择幼儿主要代养人', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                幼儿主要代养人
                <br />
                <span class="form-english-label">Primary caretaker of young children at home</span>
              </div>
              <div class="form-item-sex">
                <el-radio-group v-model="ruleForm.primaryCare">
                  <el-radio :label="12">父亲为主</el-radio>
                  <el-radio :label="13">母亲为主</el-radio>
                  <el-radio :label="14">父母共同</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item
              prop="householdRegistration"
              v-if="item.itemCode === 'householdRegistration'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入内容', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                宝宝户籍地
                <span class="form-english-label">Household Registration</span>
              </div>
              <el-input v-model="ruleForm.householdRegistration"></el-input>
            </el-form-item>
            <el-form-item
              prop="nationality"
              v-if="item.itemCode === 'nationality'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入内容', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                国籍
                <span class="form-english-label">Nationality</span>
              </div>
              <el-input v-model="ruleForm.nationality"></el-input>
            </el-form-item>
            <el-form-item
              prop="idCard"
              v-if="item.itemCode === 'idCard'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入内容', trigger: 'change' },
              { validator: checkIdCard, trigger: 'blur' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                您的身份证号
                <span class="form-english-label">ID number</span>
              </div>
              <el-input
                maxlength="18"
                v-model="ruleForm.idCard"
                :rules="[
              { required: item.isRequired == 1,vaildIdCard, message: '请输入正确的身份证号码', trigger: 'change' }]"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="mostAbout"
              v-if="item.itemCode === 'mostAbout'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入内容', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                您最想了解我们园所哪些方面
                <br />
                <span class="form-english-label">What do you want to know most about our school</span>
              </div>
              <el-input v-model="ruleForm.mostAbout"></el-input>
            </el-form-item>
            <el-form-item
              prop="careDayLife"
              v-if="item.itemCode === 'careDayLife'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入内容', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                孩子的一日生活中您最关注什么？
                <br />
                <span
                  class="form-english-label"
                >What do you care about most in your child's daily life</span>
              </div>
              <el-input v-model="ruleForm.careDayLife"></el-input>
            </el-form-item>
            <el-form-item
              prop="importantFactor"
              v-if="item.itemCode === 'importantFactor'"
              :rules="[
              { required: item.isRequired == 1, message: '请输入内容', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                您为孩子挑选幼儿园时，最看重的因素是什么?
                <br />
                <span
                  class="form-english-label"
                >What is the most important factor when selecting your children's school?</span>
              </div>
              <el-input v-model="ruleForm.importantFactor"></el-input>
            </el-form-item>
            <el-form-item
              prop="distanceHome"
              v-if="item.itemCode === 'distanceHome'"
              :rules="[
              { required: item.isRequired == 1, message: '请选择幼儿主要代养人', trigger: 'change' }]"
            >
              <div :class="'form-label ' + (item.isRequired == 1 ? 'form-label-required' : '')">
                您期望学校距离家的距离为
                <br />
                <span
                  class="form-english-label"
                >What is your desired institution's distance from your home?</span>
              </div>
              <div class="form-item-sex">
                <el-radio-group v-model="ruleForm.distanceHome">
                  <el-radio :label="15">&lt;2km</el-radio>
                  <el-radio :label="16">2-5km</el-radio>
                  <el-radio :label="17">&gt;5km</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <mt-button
          v-if="bannerImg.length > 0"
          type="default"
          @click="submitForm('ruleForm')"
          class="submit-btn"
        >预约报名 Submit</mt-button>
        <div class="garden-message" v-if="bannerImg.length > 0">
          <div>
            <i class="iconfont icon-icon_phone"></i>
            <span class="garden-message-label">联系电话</span>
            <span class="garden-message-item">{{garden.linkPhone}}</span>
          </div>
          <div>
            <i class="iconfont icon-icon_address"></i>
            <span class="garden-message-label">联系地址</span>
            <span
              class="garden-message-item"
            >{{garden.province}}{{garden.city}}{{garden.district}}{{garden.address}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cityDatas from "../../static/mock/city.js";
import { Toast, MessageBox } from "mint-ui";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      readonly: true,
      upload_url: this.$uploadUrl + "/files/uploadComplete",
      uploadHeader: {
        // 图片或者视频上传设置的请求头
        contentType: "multipart/form-data"
      },
      upload_limit: 1,
      otherNeedParams: {
        // 上传图片的参数
        folder: "food"
      },
      cityDatas: cityDatas,
      cityArr: [],
      districtArr: [],
      gardenObj: {},
      garden: {},
      ruleForm: {
        chineseName: "",
        englishName: "",
        sex: null,
        secondChildSex: null,
        birthday: "",
        secondBirthday: "",
        name: "",
        number: "",
        email: "",
        address: "",
        radio: "",
        desc: "",
        imageUrl: "",
        relationship: "",
        startDate: "",
        wechatId: "",
        currentSchool: "",
        motherAge: "",
        fatherAge: "",
        primaryCare: "",
        householdRegistration: "",
        nationality: "",
        idCard: "",
        mostAbout: "",
        careDayLife: "",
        importantFactor: "",
        distanceHome: ""
      },
      prov: "北京市",
      city: "北京市",
      district: "东城区",
      startDatePickerValue: new Date(),
      pickerValue: "",
      secondPickerValue: "",
      channel: null,
      sourceArr: [
        {
          label: "朋友推荐 Friends"
        },
        {
          label: "网络搜索 Internet"
        },
        {
          label: "户外广告 Outdoor Ad."
        },
        {
          label: "报刊杂志 Magazine"
        },
        {
          label: "线上媒体 Online Media"
        },
        {
          label: "其他 Others"
        }
      ],
      rules: {
        number: [{ validator: checkPhone, trigger: "blur" }]
      },
      bannerImg: "",
      numberError: ""
    };
  },
  mounted() {
    this.getMessage();
    this.channel = this.$route.query.channel;
  },
  beforeMount: function() {
    this.updateCity();
    this.updateDistrict();
  },
  methods: {
    checkIdCard(rule, value, callback) {
      if (!value) {
        return callback(new Error("身份证号号不能为空"));
      } else {
        var idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (idCardReg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的身份证号"));
        }
      }
    },
    testNumber(val) {
      let reg = /^1[3|4|5|8][0-9]\d{8}$/;
      if (val === 0) {
        if (
          this.ruleForm.number.length > 0 &&
          reg.test(this.ruleForm.number) === false
        ) {
          this.numberError = "请输入正确的手机号码";
        } else {
          this.numberError = "";
        }
      }
    },
    changeDate(d) {
      var year = d.getFullYear();
      var month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      return year + "-" + month + "-" + day;
    },
    birthdayHandleConfirm(val) {
      this.ruleForm.birthday = this.changeDate(val);
    },
    secondBirthdayHandleConfirm(val) {
      this.ruleForm.secondBirthday = this.changeDate(val);
    },
    startDateHandleConfirm(val) {
      this.ruleForm.startDate = this.changeDate(val);
    },
    handleAvatarSuccess(res, file) {
      // 获取头像地址
      this.ruleForm.imageUrl = res.data.url;
    },
    birthdayOpenPicker(val) {
      this.$refs.birthdayPicker[0].open();
    },
    secondBirthdayOpenPicker(val) {
      console.log(this.$refs);
      this.$refs.secondBirthdayPicker[0].open();
    },
    startDateOpenPicker(val) {
      this.$refs.startDatePicker[0].open();
    },
    submitForm(formName) {
      let params = {
        title: this.gardenObj.name,
        babyName: this.ruleForm.chineseName,
        englishName: this.ruleForm.englishName,
        sex: parseInt(this.ruleForm.sex),
        babyBirth: this.ruleForm.birthday,
        enrolment: this.ruleForm.name,
        phone: this.ruleForm.number.toString(),
        remark: this.ruleForm.desc,
        homeAddress: this.ruleForm.address,
        country: this.garden.country,
        province: this.prov,
        city: this.city,
        district: this.district,
        source: this.ruleForm.radio,
        gardenId: parseInt(this.gardenObj.gardenId),
        email: this.ruleForm.email,
        photo: this.ruleForm.imageUrl,
        channel: this.channel,
        hopeEntryTime: this.ruleForm.startDate,
        wechat: this.ruleForm.wechatId,
        relation: parseInt(this.ruleForm.relationship),
        currentSchool: this.ruleForm.currentSchool
      };
      for (const key in this.ruleForm) {
        params[key] = this.ruleForm[key];
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$post("/recruit/saveRecruitForPublic", params, "9000")
            .then(res => {
              if (res.code == "00") {
                Toast({
                  message: "报名成功",
                  iconClass: "icon icon-success"
                });
                this.getMessage();
                this.$refs[formName].resetFields();
                //北京京台园回调
                if (this.channel == 4) {
                  console.log("回调转化 agl", window._agl);
                  window._agl &&
                    window._agl.push(["track", ["success", { t: 3 }]]);
                  console.log("回调转化 agl", window._agl);
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          MessageBox.alert("您的填写有误，请检查后重新提交！");
          return false;
        }
      });
    },
    getMessage() {
      this.$post("/recruit/form/get", { id: this.$route.query.id }, "9000")
        .then(res => {
          this.gardenObj = res.data;
          this.bannerImg = this.gardenObj.theme;
          this.garden = res.data.garden;
          this.prov = res.data.garden.province;
          this.city = res.data.garden.city;
          this.district = res.data.garden.district;
          document.title = res.data.name;
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    updateCity() {
      for (var i in this.cityDatas) {
        var obj = this.cityDatas[i];
        if (obj.name == this.prov) {
          this.cityArr = obj.sub;
          break;
        }
      }
      if (this.cityArr && this.cityArr.length > 0 && this.cityArr[1].name) {
        if (
          this.prov === this.garden.province &&
          this.garden.city &&
          this.city === this.garden.city
        ) {
          this.city = this.garden.city;
        } else {
          this.city = this.cityArr[1].name;
        }
      }
    },
    updateDistrict() {
      for (var i in this.cityArr) {
        var obj = this.cityArr[i];
        if (obj.name == this.city) {
          this.districtArr = obj.sub;
          break;
        }
      }
      if (
        this.districtArr &&
        this.districtArr.length > 0 &&
        this.districtArr[1].name
      ) {
        if (this.garden.city && this.city === this.garden.city) {
          this.district = this.garden.district;
        } else {
          this.district = this.districtArr[1].name;
        }
      }
    }
  },
  watch: {
    prov: function() {
      this.updateCity();
      this.updateDistrict();
    },
    city: function() {
      this.updateDistrict();
    }
  }
};
</script>

<style lang="scss">
$default: #002d64;
$Christmas: #5b6497;
$newYear: #8c2926;
$NewYear1: #b23632;
$NewYear2: #9b2b27;
$NewYear3: #f8eee6;
$NewYear4: #f3bb89;
.container-NewYear1 {
  background: $NewYear1;
  .submit-btn {
    background: $NewYear1;
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $NewYear1;
    }
  }
  .iconfont {
    color: $NewYear1;
  }
}
.container-NewYear2 {
  background: $NewYear2;
  .submit-btn {
    background: $NewYear2;
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $NewYear2;
    }
  }
  .iconfont {
    color: $NewYear2;
  }
}
.container-NewYear3 {
  background: $NewYear3;
  .submit-btn {
    background: $NewYear3;
    .mint-button-text {
      color: #d0342e;
    }
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $NewYear3;
    }
  }
  .iconfont {
    color: $NewYear3;
  }
}
.container-NewYear4 {
  background: $NewYear4;
  .submit-btn {
    background: $NewYear4;
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $NewYear4;
    }
  }
  .iconfont {
    color: $NewYear4;
  }
}
.container-default {
  background: $default;
  .submit-btn {
    background: $default;
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $default;
    }
  }
  .iconfont {
    color: $default;
  }
}
.container-Christmas {
  background: $Christmas;
  .submit-btn {
    background: $Christmas;
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $Christmas;
    }
  }
  .iconfont {
    color: $Christmas;
  }
}
.container-newYear {
  background: $newYear;
  .submit-btn {
    background: $newYear;
  }
  .el-form .form-item-sex {
    .el-radio__input.is-checked .el-radio__inner {
      background: $newYear;
    }
  }
  .iconfont {
    color: $newYear;
  }
}
.container {
  width: 100%;
  min-width: 320px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.55rem;
  max-width: 750px;
  margin: 0 auto;
  .content {
    width: 90%;
    margin: 0 auto;
    padding: 0.11rem;
    border: 2px solid #fff;
    border-radius: 3px;
    box-sizing: border-box;
    color: #484848;
    font-family: PingFangSC-Regular;
    .content-box {
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      padding: 0.3rem;
    }
    .garden-name {
      font-size: 0.42rem;
      text-align: center;
      font-weight: bold;
      margin: 0.36rem 0 0.72rem 0;
    }
  }
  .logo {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
  .birthday {
    // width: 5.6rem;
    // height: 0.8rem;
    // border-radius: 4px;
    // box-sizing: border-box;
    // border: 1px solid #DFDFDF;
    // padding: 0 15px;
    // color: #606266;
    // outline: none; // 去除选中状态边框
    // line-height: 0.8rem;
    // font-size: 0.24rem;
  }
  .el-form-item {
    margin-bottom: 0.36rem;
  }
  .submit-btn {
    width: 4rem;
    height: 0.8rem;
    border-radius: 0.5rem;
    border: none;
    margin-bottom: 0.55rem;
    font-size: 0.3rem;
    color: #fff;
  }
  .el-form {
    .number-error {
      line-height: 0.4rem;
      color: #f56c6c;
      margin-left: 0.16rem;
      margin-top: 0.04rem;
      font-size: 0.24rem;
      position: absolute;
      top: 100%;
    }
    .el-form-item__error {
      padding-left: 0.18rem;
    }
    .address {
      display: flex;
      width: 100%;
      margin-bottom: 0.15rem;
      .el-select,
      .el-select .el-input,
      .el-select .el-input .el-input__inner {
        width: 1.7rem;
      }
      .el-select {
        margin-right: 0.15rem;
      }
      .el-input__inner {
        padding: 0 0 0 0.2rem;
        color: #767676;
      }
    }
    .form-label-required:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
    .form-label,
    .form-label-note {
      color: #484848;
      font-weight: 400;
      font-size: 0.3rem;
      text-align: left;
    }
    .form-english-label {
      font-size: 0.24rem;
      margin-left: 0.08rem;
    }
    .form-label-note {
      line-height: 0.7rem;
    }
    .know {
      line-height: 0.5rem;
    }
    .is-required {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-form-item__content {
        margin: 0;
      }
    }
    .el-form-item__content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .form-item-sex {
      width: 100%;
      text-align: left;
      margin-top: 0.2rem;
      .el-radio-group {
        width: 100%;
        display: inline;
        flex-wrap: wrap;
        .el-radio {
          width: 35%;
        }
      }
      .el-radio__input {
        border: 1px solid #767676;
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
      .el-radio {
        flex: 1;
        margin-left: 0.25rem;
        .el-radio__inner {
          border: 0.02rem solid #fff;
          left: 1px;
          top: 1px;
        }
        .el-radio__label {
          color: #767676;
          font-size: 0.26rem;
        }
      }
    }
    .radioGroup {
      width: 100%;
      .el-radio-group {
        width: 100%;
        display: flex;
        flex-direction: column;
      }
      .el-radio {
        margin: 0.15rem 0;
        margin-left: 0.15rem;
      }
    }
    .el-input,
    .el-input__inner {
      width: 5.6rem;
      height: 0.8rem;
      border-radius: 4px;
      box-sizing: border-box;
    }
    .el-input__inner {
      border: 1px solid #dfdfdf;
    }
  }
  .head-portrait {
    .head-portrait-required {
      position: absolute;
      top: -0.2rem;
    }
    .head-portrait-required:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
    .el-form-item__content {
      flex-direction: row;
    }
    .avatar-uploader {
      width: 0.8rem;
      height: 0.8rem;
      float: left;
      border-radius: 50%;
      border: 1px solid #dfdfdf;
    }
    .avatar-uploader .el-upload {
      border-radius: 6px;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #dfdfdf;
      width: 0.8rem;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
    }
    .avatar {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      display: block;
    }
    .upload-tip {
      color: red;
    }
    .head-portrait-item {
      float: left;
      width: 2rem;
      display: flex;
      flex-direction: column;
      text-align: left;
      font-size: 0.3rem;
      font-weight: 400;
      margin-right: 0.38rem;
      span {
        height: 0.42rem;
        line-height: 0.42rem;
        margin-left: 0.2rem;
      }
      .profile {
        font-size: 0.24rem;
      }
    }
  }
  .garden-message {
    width: 100%;
    div {
      width: 100%;
      display: flex;
      font-size: 0.24rem;
      line-height: 0.45rem;
      color: #484848;
      .garden-message-item {
        color: #767676;
        margin-left: 0.2rem;
      }
      .iconfont {
        margin-right: 0.15rem;
        font-size: 0.32rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue